module.exports = __webpack_public_path__ + "static/media/mmwall.1e0e09e8.png";